import React, { useEffect } from "react";
import { func, number, oneOf, string } from "prop-types";

import sourceTypes from "../../constants/sourceTypes";
import { useContactFormBehavior } from "../../redux/hooks/contactFormHooks";
import { useUIBehavior } from "../../redux/hooks/uiHooks";
import * as S from "./styled";

const DRAWER_ANIMATION_TIME = 540;

const ContactSellersAgentCTA = ({
  className,
  closeHostDrawer,
  expertsApiUuid,
  fromSource,
  listingId,
  openHostDrawer
}) => {
  const {
    closeAgentContactDrawer,
    openAgentContactDrawer,
    setModalOpener
  } = useUIBehavior();
  const { sendClickToContactCTA, setExpertInfo } = useContactFormBehavior();

  const hostModalOpener = () => {
    closeAgentContactDrawer();
    setTimeout(openHostDrawer, DRAWER_ANIMATION_TIME);
  };

  const handleClick = () => {
    closeHostDrawer();
    sendClickToContactCTA();
    setModalOpener(hostModalOpener);
    setTimeout(openAgentContactDrawer, DRAWER_ANIMATION_TIME);
  };

  useEffect(() => {
    setExpertInfo({
      expertsApiUuid,
      fromSource,
      listingId
    });
    setModalOpener(hostModalOpener);
  }, []);

  return (
    <S.Text className={className}>
      If you&apos;d like, you may{" "}
      <S.CTAButton data-qa="contact-sellers-agent-button" onClick={handleClick}>
        contact the seller&apos;s agent
      </S.CTAButton>
    </S.Text>
  );
};

ContactSellersAgentCTA.propTypes = {
  className: string,
  expertsApiUuid: string,
  fromSource: oneOf(Object.values(sourceTypes)),
  listingId: number.isRequired,
  closeHostDrawer: func,
  openHostDrawer: func
};

ContactSellersAgentCTA.defaultProps = {
  className: null,
  closeHostDrawer: () => {},
  expertsApiUuid: null,
  fromSource: null,
  openHostDrawer: () => {}
};

export default ContactSellersAgentCTA;
